const policyStatus = {
    DRAFT : 0,

    BIND_PENDING : 12,

    BOUND : 1,

    BEGIN_ISSUANCE : 2,

    PENDING_ISSUANCE : 3,

    ISSUED : 4,

    CANCELLATION_REQUESTED : 5,

    CANCELLATION_PENDING : 6,

    CANCELLED : 7,

    REPLACED : 8,

    REWRITE_PENDING : 9,

    REISSUE_PENDING : 10,

    REWRITTEN : 11

};

angular.module('gw-um-j2js')
    .constant('policyStatus', policyStatus);